/**
 * DevExtreme (esm/events/double_click.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    name,
    dblClick
} from "../__internal/events/dblclick";
import registerEvent from "./core/event_registrator";
registerEvent(name, dblClick);
export {
    name
};
